import { render, staticRenderFns } from "./ProfitReportTotalTableMobile.vue?vue&type=template&id=1c7ffc5b&scoped=true"
import script from "./ProfitReportTotalTableMobile.vue?vue&type=script&lang=js"
export * from "./ProfitReportTotalTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ffc5b",
  null
  
)

export default component.exports